function* resolveGoodsData(product, params) {
    var _a, _b;
    let current = (_a = window === null || window === void 0 ? void 0 : window.calcZV_goods) === null || _a === void 0 ? void 0 : _a[product];
    if (!current)
        return;
    let index = 0;
    yield [current, index];
    while (typeof current === "object") {
        const key = (params === null || params === void 0 ? void 0 : params[index]) || Object.keys(current.items)[0];
        if (typeof key !== "string")
            break;
        current = (_b = current === null || current === void 0 ? void 0 : current.items) === null || _b === void 0 ? void 0 : _b[key];
        yield [current, ++index];
    }
}
export default resolveGoodsData;
